module.exports = __webpack_public_path__ + "img/strap.b8a35788.svg";